import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-importar-gpx',
  templateUrl: './importar-gpx.component.html',
  styleUrls: ['./importar-gpx.component.scss']
})
export class ImportarGpxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
